import Joi from "joi";
import {
  emailSchema,
  nameSchema,
  loginSchema,
  passwordSchema,
  passwordConformationSchema,
  passwordPreviosCheckSchema,
  stringSchema,
  numberSchema,
  methodSchema,
  routeNameSchema,
  passwordOptionalSchema,
  responseSchema,
} from "./schema-components";

export const authSchema = Joi.object({
  login: loginSchema(),
  password: passwordSchema(),
});

export const registrationSchema = Joi.object({
  first_name: nameSchema(),
  last_name: nameSchema(),
  login: loginSchema().regex(/^[a-zA-Z0-9_]+$/).messages({
    'string.pattern.base': 'Логин может содержать только латинские буквы, цифры и символ подчёркивания',
  }),
  password: passwordSchema(),
  password2: passwordConformationSchema("password"),
  email: emailSchema(),
  userAgreement: Joi.boolean().invalid(false),
  personalData: Joi.boolean().invalid(false),
});

export const settingsSchema = Joi.object({
  first_name: stringSchema(),
  last_name: stringSchema(),
  old_password: passwordPreviosCheckSchema(),
  password: passwordOptionalSchema(),
  password2: passwordOptionalSchema("password"),
});

export const formSpaceSchema = Joi.object({
  name: stringSchema(),
});

export const formRouteSchema = Joi.object({
  name: routeNameSchema(),
  description: stringSchema(),
  method: methodSchema(),
  url: stringSchema(),
  http_code: numberSchema(),
  content_type: stringSchema(),
  response: responseSchema(),
  active: Joi.boolean(),
  logging_enable: Joi.boolean(),
  delay: numberSchema(),
});

export const filteredLogsSchema = Joi.object({
  startDate: Joi.date(),
  endDate: Joi.date(),
});

export const supportSchema = Joi.object({
  name: stringSchema(),
  email: emailSchema(),
  message: stringSchema(),
});

export const recoveryPasswordSchema = Joi.object({
  email: emailSchema(),
});

export const changePasswordSchema = Joi.object({
    password: passwordOptionalSchema(),
    password2: passwordConformationSchema("password"),
    login: stringSchema(),
    hash: stringSchema(),
})
